export default "__VITE_ASSET__CO2Fv8N___"